export const fullWidthSxProps = {
  width: 'calc(100% + 2 * var(--ag-grid-size)* 4)',
  marginLeft: 'calc(var(--ag-grid-size)* -4) !important',
};
